import { HStack } from "@ui/Stack";
import { Link, Text } from "@ui/typography/Text";
import { Show } from "solid-js";

type Props = {
	label: string;
	link?: string;
	linkLabel?: string;
};

export const MenuSubHeading = (props: Props) => {
	return (
		<HStack
			align="center"
			justify="space-between"
			style={{ margin: "1rem 0 0.5rem 0", padding: "0 0.5rem" }}
		>
			<div class="menu-sub-heading">
				<Text
					as="h3"
					color="fg1"
					transform="uppercase"
					weight="bold"
					size="small"
				>
					{props.label}
				</Text>
			</div>
			<Show when={props.link && props.linkLabel}>
				<Link
					href={props.link}
					color="fg4"
					hoverColor="fg1"
					transform="uppercase"
					weight="bold"
					size="small"
				>
					{props.linkLabel}
				</Link>
			</Show>
		</HStack>
	);
};
